export default "__VITE_ASSET__DS3IWJax__"